module.exports = __webpack_public_path__ + "img/bg_nodata.6d78cadc.png";